import { DownloadOutlined } from '@ant-design/icons';
import { Spin, Table } from 'antd';
import { orderBy } from 'lodash';
import { getCPAPExcel, getPatientsCPAP } from 'pages/BillingProcess/thunk';
import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { exportFile } from 'utils/export.api';
import { t_cpap_instructions, t_medical_institution } from 'types';

type Props = {
  items: t_medical_institution[];
};

const TableBilling: FC<Props> = ({ items }) => {
  const [loadingIndex, setLoadingIndex] = useState<number | undefined>(undefined);
  const history = useHistory();
  const dispatch = useDispatch();

  const exportExcel = useCallback(
    async (record: t_medical_institution, index: number) => {
      try {
        setLoadingIndex(index);
        const date = new Date();
        const dateNew = `${date.getFullYear()}年${date.getMonth() + 1}月度`;
        await dispatch(getCPAPExcel(record.i_id));
        const patients: any = await dispatch(getPatientsCPAP(record.i_id));
        const pre_patients =
          patients.payload.length > 0
            ? patients.payload.map((r: any) => {
                r.sort_num = r.sort_num == undefined || r.sort_num == null ? 99999 : Number(r.sort_num);
                return r;
              })
            : [];

        const objExport = {
          facility_name: record.facility_name,
          facility_code: record.facility_code,
          invoice_month: dateNew + 'CPAP患者様受診確認',
          in_charge_of_sales: record.in_charge_of_sales,
          patients: orderBy(pre_patients, ['sort_num', 'created_at'], ['asc', 'asc']).map(
            (r: t_cpap_instructions, i: number) => {
              return {
                index: i + 1,
                patient_name: r.patient_name ?? '',
                remark_for_output: r.remark_for_output ?? '',
                patient_id: r.patient_id ?? '',
              };
            },
          ),
        };
        await exportFile(
          objExport,
          'xlsx',
          'ExcelHexabase',
          `受診明細_${record.facility_name}_${date.getFullYear()}${('0' + (date.getMonth() + 1)).slice(-2)}`,
        );
      } finally {
        setLoadingIndex(undefined);
      }
    },
    [dispatch],
  );

  return (
    <div>
      <Table
        rowKey={`facility_code`}
        onRow={(item: t_medical_institution) => {
          return {
            onClick: () => {
              loadingIndex === undefined && history.push('billing_process/register', { medicalDetail: item });
            },
          };
        }}
        columns={[
          {
            title: '取引先番号',
            dataIndex: 'facility_code',
            key: 'facility_code',
            align: 'center',
            width: '12%',
            render(facility_code: string) {
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{facility_code}</div>,
              };
            },
          },
          {
            title: '医療機関',
            dataIndex: 'facility_name',
            key: 'facility_name',
            align: 'center',
            width: '25%',
            render(facility_name: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{facility_name}</div>,
              };
            },
          },
          {
            title: '郵便番号',
            dataIndex: 'facility_zip',
            key: 'facility_zip',
            align: 'center',
            width: '12%',
            render(facility_zip: string) {
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)' },
                  className: 'standardFont',
                },
                children: <div>{facility_zip}</div>,
              };
            },
          },
          {
            title: '所在地',
            key: 'facility_address1',
            dataIndex: 'facility_address1',
            align: 'center',
            width: '25%',
            render(facility_address1: string) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{facility_address1}</div>,
              };
            },
          },
          {
            title: 'TEL',
            key: 'facility_tel',
            dataIndex: 'facility_tel',
            align: 'center',
            width: '11%',
            render(facility_tel: string) {
              return {
                props: {
                  style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
                  className: 'standardFont',
                },
                children: <div>{facility_tel}</div>,
              };
            },
          },
          {
            title: '',
            key: '',
            dataIndex: '',
            align: 'center',
            width: '20%',
            render(text, record: t_medical_institution, index: number) {
              return {
                props: {
                  style: { background: '#A956EA', textAlign: 'center', color: 'white', cursor: 'pointer' },
                  className: 'standardFont',
                  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                    e.stopPropagation();
                    if (loadingIndex === undefined) {
                      exportExcel(record, index);
                    }
                  },
                },
                children:
                  loadingIndex === index ? (
                    <Spin size="default" />
                  ) : (
                    <>
                      受診明細出力 <DownloadOutlined />
                    </>
                  ),
              };
            },
          },
        ]}
        dataSource={items}
        pagination={false}
      />
    </div>
  );
};

export default TableBilling;
